var ChildView = require('childview');
var ConversationStatusView = require('conversationstatusview');


var ConversationView = ChildView.extend({
    className: ChildView.prototype.className + ' conversation',
    initialize: function (options) {
        this.status = new ConversationStatusView(options);

        ChildView.prototype.initialize.apply(this, arguments);
    }
});


module.exports = ConversationView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/conversationview.js
// module id = TP0+
// module chunks = 1